{
  "valid": "Geçerli"
}
